/* eslint-disable */
import Vue from "vue";
import moment from "moment";

const EMPTY_STRING = "";

function isToday(date) {
  return date.isSame(moment().startOf("day"), "d");
}

function isYesterday(date) {
  return date.isSame(
    moment()
      .subtract(1, "days")
      .startOf("day"),
    "d",
  );
}

Vue.filter("dateFilter", function(date) {
  if (new Date(date).toString() === 'Invalid Date' || +date || date.split(" ").length - 1 > 1) {
    return date
  } else if (!date) {
    return EMPTY_STRING;
  }

  const momentDate = moment(date);

  let formattedDate = "";

  // if (isToday(momentDate)) {
  //   formattedDate = momentDate.format("[Сегодня,] HH:mm");
  // } else if (isYesterday(momentDate)) {
  //   formattedDate = momentDate.format("[Вчера, ] HH:mm");
  // } else {
  //   formattedDate = momentDate.locale("ru").format("D MMMM YYYY, HH:mm");
  // }
  
  formattedDate = momentDate.locale("ru").format("DD-MM-YYYY HH:mm");

  return formattedDate;
});

Vue.filter("msToMin", function(ms) {
  const seconds = Math.floor(ms / 1000) % 60;
  const minutes = Math.floor(ms / 1000 / 60) % 60;

  const formattedSeconds = seconds < 10 ? `0${seconds}` : seconds;
  const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

  return `${formattedMinutes}:${formattedSeconds}`;
});

Vue.filter("simpleDate", function(date) {
  if (!date) {
    return "";
  }

  return moment(date).format("DD.MM.YYYY");
});

Vue.filter("days", function(daysCount) {
  let modulo = daysCount % 10;

  if (modulo === 1) {
    return `${daysCount} день`;
  }

  if (modulo > 1 && modulo < 5) {
    return `${daysCount} дня`;
  }

  if (daysCount < 20 || modulo > 5) {
    return `${daysCount} дней`;
  }
});
